module.exports = __webpack_public_path__ + "static/ITCFranklinGothicStd-Demi-e5638676b01db1dd9dbe0fb504eec6bc.woff2";